import { render, staticRenderFns } from "./DiffChart.vue?vue&type=template&id=5f6638aa"
import script from "./DiffChart.vue?vue&type=script&lang=js"
export * from "./DiffChart.vue?vue&type=script&lang=js"
import style0 from "./DiffChart.vue?vue&type=style&index=0&id=5f6638aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports